import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var range = function range(qty) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return Array.from(Array(qty).keys()).map(function (item) {
    return item + start;
  });
};
export var rangeFromTo = function rangeFromTo(start, end) {
  return range(end - start + 1, start);
};